import { connect } from 'react-redux';
import Downloads from '../../components/metadata/downloads';

import { downloadFile, toggleDownloadMenu } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		downloads: state.media.downloads,
		instance: state.instances.current,
		features: state.features,
		expanded: state.ui.show_download_menu === true
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		toggleDownloadMenu: ()=>dispatch(toggleDownloadMenu()),
		downloadFile: (download)=>dispatch(downloadFile(download))
	};
}

const DownloadsContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Downloads)

export default DownloadsContainer;